import React from "react";
import { useGame, useGameSlugs } from "@seabrookstudios/pitch2table";
import { MenuItem } from "../core/MenuItem";
import { Path } from "../Path";
import Chip from "@mui/material/Chip";
import Skeleton from "@mui/material/Skeleton";
import Public from "@mui/icons-material/Public";
import PublicOff from "@mui/icons-material/PublicOff";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 */
export const GameSlugs = ({ gameId }) => {
  const { data: game } = useGame(gameId);
  const { data: slugs = [] } = useGameSlugs(gameId);

  return (
    <MenuItem
      primary="Visibility"
      secondary={
        slugs.length === 0
          ? "Add slugs to create short urls for your game when sharing with publishers"
          : slugs.join(", ")
      }
      Chip={() =>
        !game ? (
          <Skeleton />
        ) : (
          <Chip
            icon={game.visibility === "Private" ? <PublicOff /> : <Public />}
            label={game.visibility === "Private" ? "PRIVATE" : "PUBLIC"}
            color={game.visibility === "Private" ? "info" : "warning"}
          />
        )
      }
      link={Path.game(gameId).slugs()}
    />
  );
};
